import React from 'react';
import styled from 'styled-components';

import theme from 'styles/theme';

import { H3 } from 'components/Typography';

const PageBody = styled.section`
  position: relative;
  flex: 1 1 auto;
  padding: 45px 25px;
  background: ${theme.B500};
  color: ${theme.font_primary};

  @media screen and (max-width: 800px) {
    padding: 35px 15px;
  }

  .PageBody__content {
    font-size: 20px;
    max-width: ${props => (props.compact ? '750px' : props.full ? '90%' : '1000px')};
    margin: 0 auto;
  }
`;

const PageTitle = H3.extend`
  text-align: center;
`;

export default props => (
  <PageBody {...props}>
    <div className="PageBody__content">
      {props.header && <PageTitle>{props.header}</PageTitle>}
      {props.children}
    </div>
  </PageBody>
);



// WEBPACK FOOTER //
// ./src/components/PageBody.js